import {
  EUsersChangesActions,
  UsersChangesActions,
} from '@myStore/users-changes/users-changes.actions';
import {
  initialUsersChangesState,
  IUsersChangesState,
} from '@myStore/users-changes/users-changes.state';

export const usersChangesReducers = (
  state = initialUsersChangesState,
  actions: UsersChangesActions
): IUsersChangesState => {
  switch (actions.type) {
    case EUsersChangesActions.ResetState:
      return {
        ...state,
        success: false,
        errors: null,
        isLoading: false,
      };
    case EUsersChangesActions.ResetAllTakenStudentsWorksRequest:
      return {
        ...state,
        success: false,
        errors: null,
        isLoading: true,
      };
    case EUsersChangesActions.ResetAllTakenStudentsWorksSuccess:
      return {
        ...state,
        success: true,
        errors: null,
        isLoading: false,
      };
    case EUsersChangesActions.ResetAllTakenStudentsWorksFailure:
      return {
        ...state,
        success: false,
        errors: actions.errors,
        isLoading: false,
      };
    case EUsersChangesActions.ClearResetAllTakenStudentsWorks:
      return {
        ...state,
        success: false,
        errors: null,
        isLoading: false,
      };
    case EUsersChangesActions.DeleteUserRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EUsersChangesActions.DeleteUserSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case EUsersChangesActions.DeleteUserFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EUsersChangesActions.EditUserRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EUsersChangesActions.EditUserSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case EUsersChangesActions.EditUserFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case EUsersChangesActions.SendBlockStudentRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EUsersChangesActions.SendBlockStudentSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case EUsersChangesActions.SendBlockStudentFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
      };
    case EUsersChangesActions.ClearBlockStudentErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EUsersChangesActions.SendUserUnlockRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EUsersChangesActions.SendUserUnlockSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case EUsersChangesActions.SendUserUnlockFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
      };
    case EUsersChangesActions.ClearUserUnlockErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };
    case EUsersChangesActions.SendNoteAboutStudentRequest:
    case EUsersChangesActions.EditNoteAboutStudentRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EUsersChangesActions.SendNoteAboutStudentSuccess:
    case EUsersChangesActions.EditNoteAboutStudentSuccess:
      return {
        ...state,
        success: true,
        isLoading: false,
      };
    case EUsersChangesActions.SendNoteAboutStudentFailure:
    case EUsersChangesActions.EditNoteAboutStudentFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
      };
    case EUsersChangesActions.ClearNoteAboutStudentErrors:
      return {
        ...state,
        success: false,
        errors: null,
      };

    case EUsersChangesActions.SaveStudentFinalResultsRequest:
      return { ...state, isLoading: true };
    case EUsersChangesActions.SaveStudentFinalResultsSuccess:
      return { ...state, isLoading: false };
    case EUsersChangesActions.SaveStudentFinalResultsFailure:
      return { ...state, isLoading: false, errors: actions.errors };
    case EUsersChangesActions.ClearSaveStudentFinalResults:
      return { ...state, errors: null };

    case EUsersChangesActions.DeleteStudentFinalResultRequest:
      return { ...state, isLoading: true };
    case EUsersChangesActions.DeleteStudentFinalResultSuccess:
      return { ...state, isLoading: false, success: true };
    case EUsersChangesActions.DeleteStudentFinalResultFailure:
      return { ...state, isLoading: false, errors: actions.errors };
    case EUsersChangesActions.ClearDeleteStudentFinalResult:
      return { ...state, errors: null, success: false };

    case EUsersChangesActions.DeleteHappyPointRequest:
      return { ...state, isLoading: true };
    case EUsersChangesActions.DeleteHappyPointSuccess:
      return { ...state, isLoading: false, success: true };
    case EUsersChangesActions.DeleteHappyPointFailure:
      return { ...state, isLoading: false, errors: actions.errors };
    case EUsersChangesActions.ClearDeleteHappyPoint:
      return { ...state, errors: null, success: false };

    default:
      return state;
  }
};
